import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '~/components/atoms/buttons/Button';
import analytics from '~/services/analytics';
import extension from '~/services/Extension';
import { ProfileState } from '~/store/types/profile';

const InstallExtensionButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      sx={{ '&&.MuiButtonBase-root': { padding: '6px 16px' } }}
      size="extraSmall"
      onClick={onClick}
    >
      {t('general:install', 'Install')}
    </Button>
  );
};

export type StepType = {
  checkState: (profile: ProfileState) => boolean;
  text: string;
  checkStepVisibility: () => boolean;
  Button?: FC<{ place: string }>;
};

export const useSteps = (): StepType[] => {
  const { t } = useTranslation();

  return [
    {
      text: t('general:sign_up', 'Sign Up'),
      checkState: () => true, // always true
      checkStepVisibility: () => true,
    },
    {
      text: t('general:use_first_tool', 'Use First Tool'),
      checkState: (profile: ProfileState) => profile.response_count_total > 0,
      checkStepVisibility: () => true,
    },
    {
      text: t('general:install_specific_extension', {
        extension: extension.getTitle(),
        defaultValue: 'Install {{extension}} Extension',
      }),
      checkState: () =>
        Boolean(document.getElementById('justdone-content-app')),
      checkStepVisibility: () => extension.checkIsExtensionAvailable(),
      Button: ({ place }) => (
        <InstallExtensionButton
          onClick={() => {
            analytics.trackEvent('onboarding - click step install extension', {
              place,
            });
            window.open(
              extension.getExtensionUrl(),
              '_blank',
              'noopener,noreferrer',
            );
          }}
        />
      ),
    },
  ];
};
